Shopify.stickyAddToCart = function(){
  const selector = window.isMobile ? document.querySelector(".product-form__buttons") : document.querySelector(".sticky_atc_wrap");
  const trigger = document.querySelector('.product-form__buttons');
  const summaryOffset = trigger.offsetTop + trigger.offsetHeight;

  var documentHeight = document.documentElement.scrollHeight;

  var stickyAddToCartToggle = function () {
    let windowScroll = document.documentElement.scrollTop;
    let windowHeight = window.innerHeight;
    let totalScroll = parseInt(windowScroll + windowHeight) + 60;
    if(window.isMobile){
      if (summaryOffset < windowScroll && totalScroll !== documentHeight && totalScroll < documentHeight) {
        documentHeight = document.documentElement.scrollHeight;
        selector.classList.add('sticky_atc_shown');
      } else if (totalScroll === documentHeight || totalScroll > documentHeight || summaryOffset > windowScroll) {
        selector.classList.remove('sticky_atc_shown');
      }
    } else {
      documentHeight = document.documentElement.scrollHeight;
      if (summaryOffset < windowScroll && totalScroll !== documentHeight && totalScroll < documentHeight) {
        selector.classList.add('sticky_atc_shown');
      } else if ( summaryOffset > windowScroll) {
        selector.classList.remove('sticky_atc_shown');
      }
    }
    
    
  }
  stickyAddToCartToggle()
  window.addEventListener("scroll", () => {
    stickyAddToCartToggle();
  });
  document.querySelector(".sticky_atc_js").addEventListener("click", ()=> {
    // document.querySelector(".product__info-wrapper.grid__item").scrollIntoView({behavior: "smooth"});
    const scrollDiv = document.querySelector(".product__info-wrapper.grid__item").offsetTop;
    if (scrollDiv) {
      window.scrollTo({ top: scrollDiv - 120, behavior: 'smooth'});
    }
  });
}

Shopify.stickyAddToCart();